import React, { FC } from 'react';
import { useInView } from 'react-intersection-observer';
import { VODAssetEntitlementState } from 'types/Entitlement';
import { ARROW_ANCHOR, CardWrapper } from 'components/Lane/Lane.css';
import { StandardCover } from 'types/Cover';
import { CardChannelLogo } from 'components/Cards/Card/parts/CardChannelLogo';
import { CardLink } from 'components/Cards/Card/parts/CardLink';
import { CardMedia } from 'components/Cards/Card/parts/CardMedia';
import { CardOverlays } from 'components/Cards/Card/parts/CardOverlays';
import { CardPlayButton } from 'components/Cards/Card/parts/CardPlayButton';
import { ImageWrapper, cardVariantCss } from 'components/Cards/Card/Card.css';
import { CardVariant, cardSpec } from 'components/Cards/Card/cardVariants';
import { CardPortraitWrapper, MetaData, Title } from './CardPortrait.css';

type PropTypes = {
    asset: StandardCover;
};

export const CardPortrait: FC<PropTypes> = ({ asset, ...rest }) => {
    const spec = cardSpec(CardVariant.PORTRAIT);

    const { title, image, metaData, renderPlayIcon, onPlayIconClicked, progressBar, contentMarker, rawData, assetType, channelImage } =
        asset;
    const { vodAssetState } = rawData;

    const showProgress = vodAssetState ? vodAssetState === VODAssetEntitlementState.ENTITLED : true;

    const [ref, inView] = useInView({
        threshold: 0,
    });

    return (
        <CardWrapper
            className={spec.wrapperClassName}
            height={'auto'}
            width={'auto'}
            variantCss={cardVariantCss(spec)}
            ref={ref}
            assetType={assetType}
        >
            {inView && (
                <CardLink cover={asset} style={{ display: 'inline-block', height: spec.cardHeight, width: spec.width }} {...rest}>
                    <CardPortraitWrapper data-test-id={spec.testId}>
                        <ImageWrapper className="focus-image-wrapper" {...{ [ARROW_ANCHOR]: '' }}>
                            <CardPlayButton visible={renderPlayIcon} onPlay={onPlayIconClicked} />
                            <CardMedia image={image} fallbackImage={spec.fallbackImage} showInsetPortrait={false} />
                            <CardChannelLogo src={channelImage} channelName={rawData?.channelName} />
                            <CardOverlays progressBar={progressBar} contentMarker={contentMarker} showProgress={showProgress} />
                        </ImageWrapper>
                        <Title>{title}</Title>
                        {metaData && <MetaData>{metaData}</MetaData>}
                    </CardPortraitWrapper>
                </CardLink>
            )}
        </CardWrapper>
    );
};
